
module.exports = function envJudge () {
  if (process.env.VUE_APP_BASE_API_JAVA.includes('dev')) {
    return '/dev/';
  } else if (process.env.VUE_APP_BASE_API_JAVA.includes('test')) {
    return '/test/';
  } else if (process.env.VUE_APP_BASE_API_JAVA.includes('rc')) {
    return '/rc/';
  } else {
    return '/';
  }
};
